import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadOptionComponent } from './popover/lead-option/lead-option.component';
import { HeaderAddComponent } from './popover/header-add/header-add.component';
import { GridViewModule } from './grid-view/grid-view.module';
import { IonicModule } from '@ionic/angular';
import { ColumnSelectComponent } from './modal/column-select/column-select.component';
import { PaginationComponent } from './pagination/pagination.component';
import { SearchSelectorComponent } from './search-selector/search-selector.component';
import { FilterPipe } from "./pipes/filter.pipe";
import { MultiSelectDropdownComponent } from './inputs/multi-select-dropdown/multi-select-dropdown.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { IncrementNumberInputComponent } from './inputs/increment-number-input/increment-number-input.component';
import { DatetimePickerComponent } from './inputs/datetime-picker/datetime-picker.component';
import { SelectTextInputComponent } from './inputs/select-text-input/select-text-input.component';
import { TableColumnOptionsComponent } from './popover/table-column-options/table-column-options.component';
import { DropdownSelectComponent } from './inputs/dropdown-select/dropdown-select.component';
import { LiveSearchComponent } from './inputs/live-search/live-search.component';
import { ReminderInputComponent } from './inputs/reminder-input/reminder-input.component';
import { RelatedtoDataInputComponent } from './inputs/relatedto-data-input/relatedto-data-input.component';
import { DatePickerComponent } from './inputs/date-picker/date-picker.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResponseNotificaionComponent } from './response-notificaion/response-notificaion.component';
import { TravelServiceInputComponent } from './inputs/travel-service-input/travel-service-input.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DestinationDaysInputComponent } from './inputs/destination-days-input/destination-days-input.component';
import { NoOfGuestsInputComponent } from './inputs/no-of-guests-input/no-of-guests-input.component';
import { PhoneCountryInputComponent } from './inputs/phone-country-input/phone-country-input.component';
import { AssigningUsersInputComponent } from './inputs/assigning-users-input/assigning-users-input.component';
import { LocationsAutocompleteComponent } from './inputs/locations-autocomplete/locations-autocomplete.component';
import { BlurOnMousewheelDirective } from './directive/blur-on-mousewheel.directive';
import { QuotesTableOptionsComponent } from './popover/quotes-table-options/quotes-table-options.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MultiLineGraphComponent } from './graphs/multi-line-graph/multi-line-graph.component';
import { DoughnutChartGraphComponent } from './graphs/doughnut-chart-graph/doughnut-chart-graph.component';
import { HorizontalBarGraphComponent } from './graphs/horizontal-bar-graph/horizontal-bar-graph.component';
import { VerticalBarGraphComponent } from './graphs/vertical-bar-graph/vertical-bar-graph.component';
import { MultiPointInputComponent } from './inputs/multi-point-input/multi-point-input.component';
import { DatetimeComponent } from './popover/datetime/datetime.component';
import { PersonOptionsComponent } from './popover/person-options/person-options.component';
import { DraggableBoardModule } from './draggable-board/draggable-board.module';
import { ImageViewComponent } from './image-view/image-view.component';
import { CostPricingInputComponent } from './inputs/cost-pricing-input/cost-pricing-input.component';
import { GuestDocumentComponent } from './popover/guest-document/guest-document.component';
import { MeetingDatetimeInputComponent } from './inputs/meeting-datetime-input/meeting-datetime-input.component';
import { MultiSelectLocationsComponent } from './inputs/multi-select-locations/multi-select-locations.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TemplateOptionsComponent } from './popover/template-options/template-options.component';
import { SwitchUserComponent } from './popover/switch-user/switch-user.component';
import { MultiSelectItemsComponent } from './popover/multi-select-items/multi-select-items.component';
import { MultiSelectCheckboxInputComponent } from './inputs/multi-select-checkbox-input/multi-select-checkbox-input.component';
import { ImportantInformationComponent } from '../inventory-itinerary/add/important-information/important-information.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InclusionsAndExclusionsComponent } from '../inventory-itinerary/add/inclusions-and-exclusions/inclusions-and-exclusions.component';
import { TermsAndConditionsComponent } from '../inventory-itinerary/add/terms-and-conditions/terms-and-conditions.component';
import { CancellationPolicyComponent } from '../inventory-itinerary/add/cancellation-policy/cancellation-policy.component';
import { FilterPopoverComponent } from './popover/filter-popover/filter-popover.component';
import { TimePickerComponent } from './inputs/time-picker/time-picker.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { FilterDestinationPopoverComponent } from './popover/filter-destination-popover/filter-destination-popover.component';
import { MealPlanInputComponent } from '../inventory-itinerary/add/accomodation/meal-plan-input/meal-plan-input.component';
import { RestrictSpecialCharsDirective } from './directive/restrict-special-chars.directive';
import { RestrictNumbersDirective } from './directive/restrict-numbers.directive';
import { NumbersOnlyDirective } from './directive/numbers-only.directive';
import { MaxLengthDirective } from './directive/max-length.directive';
import { TextFormattingInputComponent } from './inputs/text-formatting-input/text-formatting-input.component';
import { NgxEditorModule } from 'ngx-editor';
import { SendViaSocialMediaComponent } from './popover/send-via-social-media/send-via-social-media.component';
import { VisaPassengerGridComponent } from '../visa/visa-passenger-grid/visa-passenger-grid.component';
import { CountriesDropdownInputComponent } from './inputs/countries-dropdown-input/countries-dropdown-input.component';
import { NotificationPopoverComponent } from './popover/notification-popover/notification-popover.component';
import { FirstNameSalutationComponent } from './inputs/first-name-salutation/first-name-salutation.component';
import { AddressFieldsComponent } from './inputs/address-fields/address-fields.component';
import { SmPlainTextComponent } from './popover/sm-plain-text/sm-plain-text.component';
import { StatusProgressBarInputComponent } from '../visa/add/document-collection/status-progress-bar-input/status-progress-bar-input.component';
import { LeadEmailInputComponent } from './popover/lead-email-input/lead-email-input.component';
import { MultiSelectCustomInputDropdownComponent } from './inputs/multi-select-custom-input-dropdown/multi-select-custom-input-dropdown.component';
import { CustomDatePickerComponent } from './inputs/custom-date-picker/custom-date-picker.component';
import { CalenderInputComponent } from './inputs/calender-input/calender-input.component';
import { ClockInputComponent } from './inputs/clock-input/clock-input.component';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { SelectableListItemsComponent } from './inputs/selectable-list-items/selectable-list-items.component';
import { DmcTravelServicesInputComponent } from '../dmc-lead-management/add/dmc-travel-services-input/dmc-travel-services-input.component';
import { AuditHistoryViewComponent } from './audit-history-view/audit-history-view.component';
import { CommonFormFieldsComponent } from './popover/common-form-fields/common-form-fields.component';
import { GstNumberInputComponent } from './inputs/gst-number-input/gst-number-input.component';
import { GstInputValueDirective } from './directive/gst-input-value.directive';
import { WhatsappNumberInputComponent } from './popover/whatsapp-number-input/whatsapp-number-input.component';

@NgModule({
    declarations: [
        LeadOptionComponent,
        HeaderAddComponent,
        ColumnSelectComponent,
        QuotesTableOptionsComponent,
        PaginationComponent,
        SearchSelectorComponent,
        // Input component
        MultiSelectDropdownComponent,
        IncrementNumberInputComponent,
        DatetimePickerComponent,
        DatePickerComponent,
        TimePickerComponent,
        SelectTextInputComponent,
        TableColumnOptionsComponent,
        TemplateOptionsComponent,
        DropdownSelectComponent,
        LiveSearchComponent,
        ReminderInputComponent,
        RelatedtoDataInputComponent,
        DestinationDaysInputComponent,
        NoOfGuestsInputComponent,
        TravelServiceInputComponent,
        PhoneCountryInputComponent,
        AssigningUsersInputComponent,
        CostPricingInputComponent,
        MultiPointInputComponent,
        ResponseNotificaionComponent,
        SpinnerComponent,
        LocationsAutocompleteComponent,
        DatetimeComponent,
        PersonOptionsComponent,
        ImageViewComponent,
        GuestDocumentComponent,
        MeetingDatetimeInputComponent,
        MultiSelectLocationsComponent,
        SwitchUserComponent,
        StatusProgressBarInputComponent,
        MultiSelectItemsComponent,
        MultiSelectCheckboxInputComponent,
        TextFormattingInputComponent,
        CountriesDropdownInputComponent,
        FirstNameSalutationComponent,
        AddressFieldsComponent,
        MultiSelectCustomInputDropdownComponent,
        CalenderInputComponent,
        ClockInputComponent,
        CustomDatePickerComponent,
        BulkUploadComponent,
        SelectableListItemsComponent,
        DmcTravelServicesInputComponent,
        AuditHistoryViewComponent,
        GstNumberInputComponent,
        // Directives
        BlurOnMousewheelDirective,
        RestrictSpecialCharsDirective,
        RestrictNumbersDirective,
        NumbersOnlyDirective,
        MaxLengthDirective,
        GstInputValueDirective,
        // charts
        MultiLineGraphComponent,
        DoughnutChartGraphComponent,
        HorizontalBarGraphComponent,
        VerticalBarGraphComponent,

        // Popovers
        FilterPopoverComponent,
        FilterDestinationPopoverComponent,
        SendViaSocialMediaComponent,
        NotificationPopoverComponent,
        SmPlainTextComponent,
        LeadEmailInputComponent,
        CommonFormFieldsComponent,
        WhatsappNumberInputComponent,

        // Itinerarary shared components
        ImportantInformationComponent,
        InclusionsAndExclusionsComponent,
        TermsAndConditionsComponent,
        CancellationPolicyComponent,
        MealPlanInputComponent,

        // Visa shared components
        VisaPassengerGridComponent
    ],
    exports: [
        LeadOptionComponent,
        HeaderAddComponent,
        GridViewModule,
        DraggableBoardModule,
        ColumnSelectComponent,
        PaginationComponent,
        SearchSelectorComponent,
        RouterModule,
        MultiSelectDropdownComponent,
        IncrementNumberInputComponent,
        DatetimePickerComponent,
        DatePickerComponent,
        TimePickerComponent,
        SelectTextInputComponent,
        TableColumnOptionsComponent,
        DropdownSelectComponent,
        LiveSearchComponent,
        ReminderInputComponent,
        RelatedtoDataInputComponent,
        DestinationDaysInputComponent,
        NoOfGuestsInputComponent,
        TravelServiceInputComponent,
        PhoneCountryInputComponent,
        AssigningUsersInputComponent,
        CostPricingInputComponent,
        MultiPointInputComponent,
        ResponseNotificaionComponent,
        SpinnerComponent,
        LocationsAutocompleteComponent,
        ImageViewComponent,
        GuestDocumentComponent,
        MeetingDatetimeInputComponent,
        MultiSelectLocationsComponent,
        StatusProgressBarInputComponent,
        MultiSelectItemsComponent,
        MultiSelectCheckboxInputComponent,
        TextFormattingInputComponent,
        CountriesDropdownInputComponent,
        FirstNameSalutationComponent,
        AddressFieldsComponent,
        MultiSelectCustomInputDropdownComponent,
        CustomDatePickerComponent,
        CalenderInputComponent,
        ClockInputComponent,
        BulkUploadComponent,
        SelectableListItemsComponent,
        DmcTravelServicesInputComponent,
        GstNumberInputComponent,
        // Directives
        RestrictSpecialCharsDirective,
        RestrictNumbersDirective,
        NumbersOnlyDirective,
        MaxLengthDirective,
        GstInputValueDirective,
        // charts
        MultiLineGraphComponent,
        DoughnutChartGraphComponent,
        HorizontalBarGraphComponent,
        VerticalBarGraphComponent,

        // popover
        FilterPopoverComponent,
        FilterDestinationPopoverComponent,
        CommonFormFieldsComponent,

        // Itinerary shared components
        ImportantInformationComponent,
        InclusionsAndExclusionsComponent,
        TermsAndConditionsComponent,
        CancellationPolicyComponent,
        MealPlanInputComponent,

        // visa shared components
        VisaPassengerGridComponent
        
    ],
    imports: [
        CommonModule,
        GridViewModule,
        DraggableBoardModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        FilterPipe,
        RouterModule,
        NgxChartsModule,
        NgxEditorModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot()
    ]
})
export class SharedModule { }
